import type { AxiosRequestConfig } from 'axios';
import { Page, PaginationParams } from '@/shared/api/pagination';
import type {
  AccessRuleResponse,
  AccessRuleUpdateRequest,
} from '@/entities/user/access-rule';
import type {
  AccessRuleBriefDashboardDTOResponse,
  AccessRuleCreateRequest,
} from '@/entities/user/access-rule';
import { srmInstance } from '@/shared/api/api-instances/srm/api-instance';

export class AccessRulesApi {
  static getActions(options: AxiosRequestConfig = {}) {
    return srmInstance.get(`/rules/actions`, options);
  }

  static getAccesses(options: AxiosRequestConfig = {}) {
    return srmInstance.get(`/rules/accesses`, options);
  }

  static getRuleList(
    params: PaginationParams,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.get<AccessRuleResponse[]>(`/rule`, {
      ...options,
      params,
    });
  }

  static getRuleListBrief(
    params: PaginationParams,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.get<Page<AccessRuleBriefDashboardDTOResponse>>(
      `/rule_brief`,
      {
        ...options,
        params,
      },
    );
  }

  static createRule(
    payload: AccessRuleCreateRequest,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.post<AccessRuleResponse>(`/rule`, payload, options);
  }

  static updateRule(
    id: string,
    payload: AccessRuleUpdateRequest,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.put<AccessRuleResponse>(`/rule/${id}`, payload, options);
  }

  static removeRule(id: string, options: AxiosRequestConfig = {}) {
    return srmInstance.delete(`/rule/${id}`, options);
  }

  static getRule(id: string, options: AxiosRequestConfig = {}) {
    return srmInstance.get(`/rule/${id}`, options);
  }
}